import React from "react";
import { BellIcon } from "lucide-react";
import { dashboardAllocation, dashboardContracts, team } from "../../data/home";
export function ClientDashboardPreview() {
  return <div className="rounded-[28px] border border-night-line bg-night-card p-5 md:p-7" role="img" aria-label="Aperçu de l’espace client : patrimoine total, répartition et contrats" data-id="element-4" data-mp="dq524nztnm7c">
      <div className="flex items-center justify-between" data-id="element-5" data-mp="16f2iumodxaxz">
        <div className="flex items-center gap-3" data-id="element-6" data-mp="16fkkxzxqajdt">
          <img src={team[0].image} alt="" className="h-9 w-9 rounded-full object-cover" data-id="element-7" data-mp="1bef26xg1rzvt" />
          <div data-id="element-8" data-mp="wog7j4npb6l3">
            <p className="text-sm font-semibold text-canvas" data-id="element-9" data-mp="wmwr9e21ovjb">Bonjour Marie</p>
            <p className="text-xs text-canvas/50" data-id="element-10" data-mp="11mhq7oh7t3w1">Dernière mise à jour aujourd’hui, 08:30</p>
          </div>
        </div>
        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-night-line text-canvas/80" data-id="element-11" data-mp="1pbk4cmcn4els">
          <BellIcon className="h-4 w-4" aria-hidden="true" data-id="element-12" data-mp="1u67xwzmi3z78" />
        </span>
      </div>

      <div className="mt-8 grid gap-6 md:grid-cols-[1.2fr_1fr]" data-id="element-13" data-mp="26fcmsthqb5kh">
        <div data-id="element-14" data-mp="21jf8sttxubav">
          <p className="text-sm text-canvas/55" data-id="element-15" data-mp="21jxcgbixjrst">Patrimoine total</p>
          <p className="mt-1 text-[40px] font-semibold leading-none tracking-tight text-canvas" data-id="element-16" data-mp="2g7iavs4v12ue">
            248 560 €
          </p>
          <p className="mt-2 text-sm font-medium text-gain-soft" data-id="element-17" data-mp="2beyw4rufs1o0">+14 980 € · +6,4 % sur 12 mois</p>
        </div>
        <div data-id="element-18" data-mp="2pa1dcb4qhdg4">
          <p className="text-sm text-canvas/55" data-id="element-19" data-mp="2p9rncnjov6af">Répartition</p>
          <div className="mt-3 flex h-2.5 overflow-hidden rounded-full" data-id="element-20" data-mp="2k8c0qr1v4rpx">
            {dashboardAllocation.map(a => <span key={a.label} style={{
            width: `${a.share}%`,
            background: a.color
          }} data-id="element-21" data-mp="2z41p2vuitgxt" />)}
          </div>
          <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5" data-id="element-22" data-mp="14s3i70joox53">
            {dashboardAllocation.map(a => <li key={a.label} className="flex items-center gap-2 text-xs text-canvas/70" data-id="element-23" data-mp="ztjtisdph791">
                <span className="h-2 w-2 rounded-full" style={{
              background: a.color
            }} data-id="element-24" data-mp="1phfia02z6cg2" />
                {a.label}
                <span className="ml-auto text-canvas/45" data-id="element-25" data-mp="1thzduz7wh803">{a.share} %</span>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="mt-8 rounded-2xl bg-night" data-id="element-26" data-mp="1ygj43btj15y9">
        {dashboardContracts.map(c => <div key={c.name} className="flex items-center justify-between gap-4 border-b border-night-line px-4 py-4 last:border-b-0 md:px-5" data-id="element-27" data-mp="23i8dyo50jdkr">
            <p className="truncate text-sm font-medium text-canvas" data-id="element-28" data-mp="2cgallmj954h0">{c.name}</p>
            <div className="flex shrink-0 items-center gap-4" data-id="element-29" data-mp="2h821n34s7rsw">
              <span className="text-sm text-gain-soft" data-id="element-30" data-mp="2haocpcqvspfv">{c.perf}</span>
              <span className="w-24 text-right text-sm font-semibold text-canvas" data-id="element-31" data-mp="2m6ws8r8zqknk">{c.value}</span>
            </div>
          </div>)}
      </div>

      <div className="mt-4 flex items-start gap-3 rounded-2xl border border-night-line p-4" data-id="element-32" data-mp="2w52vpdag3yuj">
        <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-gain-soft" aria-hidden="true" data-id="element-33" data-mp="khzgkbh6zm7h" />
        <p className="text-sm leading-relaxed text-canvas/70" data-id="element-34" data-mp="fjfodtc09e6o">
          <span className="font-semibold text-canvas" data-id="element-35" data-mp="fl8yxjpqoijy">Quentin · </span>
          Suite à la baisse des taux, je vous propose un arbitrage vers le fonds euros
          boosté. Votre avenant est prêt à signer.
        </p>
      </div>
    </div>;
}